import { useLanguage } from "../context/LanguageContext";
import ContentPage from "./ContentPage";

export default function Press() {
  const { isRTL } = useLanguage();

  return (
    <ContentPage
      title={isRTL ? "الصحافة" : "Press"}
      eyebrow={isRTL ? "الإعلام" : "Media"}
    >
      <p className="lead">
        {isRTL ? (
          <>
            للاستفسارات الصحفية، الصور عالية الدقة، والمقابلات مع المؤسسين، يرجى مراسلتنا عبر البريد الإلكتروني{" "}
            <a href="mailto:press@terryland.net" style={{ color: "var(--gold-dark)" }}>
              press@terryland.net
            </a>
            .
          </>
        ) : (
          <>
            For press inquiries, hi-res imagery, and founder interviews, please email{" "}
            <a href="mailto:press@terryland.net" style={{ color: "var(--gold-dark)" }}>
              press@terryland.net
            </a>
            .
          </>
        )}
      </p>
    </ContentPage>
  );
}
